import styled from 'styled-components';
import { SCREEN_MD } from 'shared/consts/styleValues';

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 34px;
  padding: 14px 0;
	margin-left: 15px;
	margin-right: 15px;
	margin-bottom: 10px;
  	box-sizing: border-box;

	@media only screen and (min-device-width: 768px) and (max-device-width: 820px) and (orientation: portrait) {
		gap: 15px;
	}

	@media only screen and (min-device-width: 1024px) and (max-device-width: 1024px) and (orientation: landscape) {
		gap: 15px;
	}

	@media (max-width: 768px) {
		gap: 0;
		column-gap: 15px;
		justify-content: space-between;
	}
`;

export const Column = styled.div``;

export const ProfileContainer = styled.div`
	position: relative;

	@media (min-width: ${SCREEN_MD}px) {
    margin-left: auto;
	}
`;

export const ProfilePopover = styled.div`
	position: absolute;
	top: 50px;
	right: 0px;
	background: #fff;
	width: 180px;
	z-index: 2;
	padding: 8px;
	border-radius: 10px;
	display: flex;
	flex-direction: column;
	align-items: stretch;
`;